class ProductCarousel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    console.log("does this run");
    this.carousel = this.querySelector(".carousel--root");
    this.media = this.carousel.querySelectorAll(".product-media--root");
    this.transition_container = this.carousel.querySelector(".carousel--x-container");
    this.carousel.on("loaded", () => {
      this.updateMediaListener();
      this.onSlideFinishedListener();
      var element = this.querySelector('.product-media--root[data-active="true"]');
      this.goToSlide(element.dataset.id || 0);
    });
  }
  updateMediaListener() {
    window.on(`theme:product:${this.dataset.id}:variantChanged`, ({
      detail : {
        variant : page
      }
    }) => {
      var size_buffer = page.featured_media ? parseInt(page.featured_media.id) : 0;
      console.log("Go to slide", size_buffer);
      this.goToSlide(size_buffer);
    });
  }
  onSlideFinishedListener() {
    this.transition_container.on("transition:at_end", () => {
      var name = this.carousel.active_slide - 1;
      var object = this.media[name];
      this.media.not(object).forEach((elem2) => {
        return elem2.firstChild.trigger("pauseMedia");
      });
    });
  }
  goToSlide(value) {
    console.log("going to slide", value)
    var c;
    var control;
    if (0 !== value && (c = this.carousel.querySelector(`.product-media--root[data-id='${value}']`))) {
      control = c.closest(".carousel--block").index() + 1;
      this.carousel.updateThenGoToActiveSlide(control);
    }
  }
}
const productCarouselEl = customElements.get("product-media-carousel");
if (!productCarouselEl) {
  customElements.define("product-media-carousel", ProductCarousel);
}